<!-- 柱状图 -->
<style lang="less" scoped>
.bar-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .title {
    width: 35600/1920vw;
    height: 4200/1080vh;
    background: url("../../../../../assets/img/yinxiao/peopleTitle.png")
      no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
  }
  .main {
    position: relative;
    .left {
      width: 12700/1080vh;
      height: 12700/1080vh;
      position: absolute;
      top: 2500/1080vh;
      left: 2000/1920vw;
      background: url("../../../../../assets/img/yinxiao/woman.png") no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
    }
    .center {
      position: absolute;
      left: 0;
      right: 0;
      top:-2000/1920vw;
      width: 28000/1920vw;
      height: 26200/1080vh;
      background: url("../../../../../assets/img/yinxiao/people.png") no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
    }
    .right {
      position: absolute;
      width: 12700/1080vh;
      height: 12700/1080vh;
      top: 2500/1080vh;
      right: 2000/1920vw;
      background: url("../../../../../assets/img/yinxiao/man.png") no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
    }
    .right,
    .left {
      p,
      .count {
        font-size: 2000/1080vh;
        font-family: Microsoft YaHei;
        font-weight: bold;
        text-align: center;
        color: rgba(255, 255, 255, 1);
        line-height: 3000/1080vh;
      }
      p:nth-child(1) {
        margin-top: 3500/1080vh;
      }
      p:nth-child(3) {
        margin-top: 5000/1080vh;
        .count {
          font-size: 2600/1080vh;
          span {
            font-size: 1400/1080vh;
          }
        }

        // font-size: 2000/1080vh;
        // font-family: Microsoft YaHei;
        // font-weight: bold;
        // text-align: center;
        // color: rgba(255, 255, 255, 1);
      }
    }
  }
}
</style>

<template>
  <div class="bar-wrap">
    <div class="title"></div>
    <div class="main">
      <div class="left">
        <p>67.95%</p>
        <p>女</p>
        <p>
          <countTo
            class="count"
            :startVal="0"
            :endVal="634"
            :duration="5000"
          ></countTo
          ><span>人</span>
        </p>
      </div>

      <div class="center"></div>
      <div class="right">
        <p>32.05%</p>
        <p>男</p>
        <p>
          <countTo
            class="count"
            :startVal="0"
            :endVal="430"
            :duration="5000"
          ></countTo
          ><span>人</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import countTo from "vue-count-to";

export default {
  data() {
    return {
      name: "新生男女比例"
    };
  },
  components: {
    countTo
  },
  methods: {
  },
  async mounted() {
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?419a4e26